import request from '@/utils/request'

let DotaskApi = {

  /*做任务列表*/
  list(data) {
    return request._post('/shop/plus.dotask.Index/index', data);
},
/*添加做任务*/
add(data) {
    return request._post('/shop/plus.dotask.Index/add', data);
},
/*修改做任务*/
edit(data) {
    return request._post('/shop/plus.dotask.Index/edit', data);
},
/*删除做任务*/
del(data) {
    return request._post('/shop/plus.dotask.Index/del', data);
},
/*做任务详情*/
detail(data) {
  return request._post('/shop/plus.dotask.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.dotask.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.dotask.Setting/getSetting', data, errorback);
    },

      /*任务记录*/
      log(data) {
    return request._post('/shop/plus.dotask.Index/log', data);
},
delLog(data) {
    return request._post('/shop/plus.dotask.Index/delLog', data);
},
detailLog(data) {
    return request._post('/shop/plus.dotask.Index/detailLog', data);
  },
  editLog(data) {
    return request._post('/shop/plus.dotask.Index/editLog', data);
},
}
export default DotaskApi;



// WEBPACK FOOTER //
// ./src/api/dotask.js